import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  Linkable
} from "./chunk.HRTOWRLV.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-anchor/jb-anchor.scss?inline
var jb_anchor_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  color: inherit;
  display: block;
  font: inherit;
}

a.inactive {
  cursor: default;
  opacity: 0.4;
  pointer-events: none;
}`;

// src/components/jb-anchor/jb-anchor.ts
var JbAnchor = class extends Linkable(r2) {
  constructor() {
    super(...arguments);
    this.flyPadding = "";
    this.forceHover = false;
    this.inactive = false;
  }
  render() {
    const classes = {
      inactive: !!this.inactive,
      hover: !!this.forceHover
    };
    return ke`<a
      data-linkable
      class="${Rt(classes)}"
      .tabIndex="${this.inactive ? -1 : 0}"
      part="anchor"
      data-fly-padding="${this.flyPadding ?? D}"
      ><slot></slot
    ></a>`;
  }
};
JbAnchor.styles = r(jb_anchor_default);
__decorateClass([
  n()
], JbAnchor.prototype, "flyPadding", 2);
__decorateClass([
  n({ type: Boolean })
], JbAnchor.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbAnchor.prototype, "inactive", 2);
JbAnchor = __decorateClass([
  customElement("jb-anchor")
], JbAnchor);

export {
  JbAnchor
};
